import React, { useEffect, useMemo } from 'react';
import { differenceWith as _differenceWith } from 'lodash';
import { RootStateOrAny, useDispatch, useSelector } from 'react-redux';
import {
  getCountries,
  getRegions
} from '../../../redux/actions/regionsActions';
import styles from '../styles';

import { TreeSelectorInput } from '../../../components/TreeSelector';
import { useTranslation } from 'react-i18next';

export function CountryRegionSelector({
  availability=[],
  invariants=[],
  handleAvailabilityChanged= (selection) => {},
  disabled = false,
}: any) {
  const dispatch: any = useDispatch();
  const { t } = useTranslation();
  const { regions, countriesByRegion } = useSelector(
    (state: RootStateOrAny) => state.RegionsReducer,
  );
  
  const classes = styles();

  const places = useMemo(() => {
    const rootNode = {
      type: 'Root',
      text: 'Global',
      path: '/',
      metas: {
        regionId: 'GLOBAL',
      },
      hasChildren: true,
    };
    const regionNodes = regions.map(region => {
      const regionPath = `${rootNode.path}${region.id}`;
      return {
        type: 'Region',
        text: region.name,
        path: regionPath,
        hasChildren: true,
        metas: {
          region: region.id,
        },
        children: countriesByRegion[region.id]?.map(country => {
          const countryPath = `${regionPath}/${country.id}`;
          return {
            type: 'Country',
            text: t(
              `app.common.countries.${country.iso3}`,
              country.description,
            ),
            path: countryPath,
            metas: {
              countryId: country.id,
            },
          };
        }),
      };
    });
    return [{ ...rootNode, children: regionNodes }];
  }, [regions, countriesByRegion, t]);

  useEffect(() => {
    if (regions?.length === 0) dispatch(getRegions());
  }, []);

  const handleLocationTreeExpanded = ({ type, metas }: any) => {
    switch (type) {
      case 'Region':
        if (!countriesByRegion[metas.region])
          dispatch(getCountries(metas.region));
        break;
      default:
        break;
    }
  };

  const handleChange = (geographies) => {
    const isExactMatch = (a, b) => a.path === b.path;
    const isPrefixMatch = (a, b) => a.path.startsWith(`${(b.path || '')}${(b.path || '').endsWith('/') ? '' : '/'}`);
    const isMatch = (a, b) => isExactMatch(a, b) || isPrefixMatch(a, b);
    const dedupedGeographies = _differenceWith(geographies, invariants, isMatch);
    const dedupedInvariants = _differenceWith(invariants, dedupedGeographies, isMatch);
    handleAvailabilityChanged([...dedupedInvariants, ...dedupedGeographies]);
  };

  return (
      <div style={{
        width:"49%"
      }}>
      <TreeSelectorInput
          label={"Country, Region, etc. "}
          onChange={handleChange}
          classname={[classes.attributeField]}
          nodes={places}
          checkDisabled={disabled}
          disabled={disabled}
          required={true}
          value={availability || []}
          invariants={invariants || []}
          onTreeNodesExpanded={handleLocationTreeExpanded}
      />

      </div>
  );
}
